/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Styled tabs
 *
 * @file BookAndPageTabsStyle.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';

const BookAndPageTabsStyle = withStyles((theme) => ({
  root: {
    background: theme.color.toggle,
    color: theme.color.textPrimary,
    border: theme.activeTheme !== 'default' ? '1px solid rgba(155, 161, 173, 0.2)' : 'none',
    borderRadius: 41,
    minHeight: 40,
    width: 164
  },
  indicator: {
    height: 0
  }
}))(Tabs);

export default BookAndPageTabsStyle;
